// extracted by mini-css-extract-plugin
export default {"password-help-text":"settings_password-help-text__Vs8sW","password-input":"settings_password-input__z0EOM"};